export function formatCount(count: number): string {
  if (count < 100_000) {
    return count.toLocaleString();
  }

  if (count < 1_000_000) {
    return (count / 1000).toFixed(2) + 'k';
  }

  if (count < 1_000_000_000) {
    return (count / 1_000_000).toFixed(2) + 'm';
  }

  return (count / 1_000_000_000).toFixed(2) + 'b';
}
